module.exports = __webpack_public_path__ + "static/media/Cumming_11.491928ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/Cumming_11.jpg
// module id = 458
// module chunks = 0